import { Content, isFilled } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { FC } from "react";

import CohortListingImpl from "../../components/CohortListing";
import RichText from "../../components/RichText";
import Wrapper from "../../components/SliceWrapper";

import type { SliceContext } from "../types";

/**
 * Props for `CohortListing`.
 */
export type CohortListingProps = SliceComponentProps<
  Content.CohortListingSlice,
  SliceContext
>;

/**
 * Component for "CohortListing" Slices.
 */
const CohortListing: FC<CohortListingProps> = ({ slice, context }) => {
  const { cohortData, isCoursePage } = context;

  return (
    <div>
      {/* @ts-expect-error — SliceWrapper is an untyped JS component */}
      <Wrapper data-analytics-component="cohort-listing" slice={slice}>
        <div className="rte section-heading">
          <RichText field={slice.primary.heading} />
        </div>
        {cohortData.length ? (
          <CohortListingImpl
            cohorts={cohortData}
            slice={slice}
            isCoursePage={isCoursePage}
          />
        ) : (
          <div className="pt-4 font-bold">
            {isFilled.richText(slice.primary.empty_text) ? (
              <RichText field={slice.primary.empty_text} />
            ) : (
              "We currently have no available cohorts. Please check back for more cohort options in the coming months."
            )}
          </div>
        )}
      </Wrapper>
    </div>
  );
};

export default CohortListing;
